<app-nav class="w-100"></app-nav>
<section class="banner">

    <app-category-searchbar [searchText]="searchQuery" [colors]="colors"></app-category-searchbar>

    <!-- <div #air id="air" class='air kenburns-top'></div> -->
</section>
<app-no-data *ngIf="!skelition && (!currentItem || currentItem.fields?.length == 0)"></app-no-data>
<app-skelitions [hidden]="!skelition" [value]="7"></app-skelitions>
<div class="container-fluid v4-bg-img" *ngIf="currentItem && currentItem.fields.length > 0">

    <div class="row">

        <div class="col-12 d-flex justify-content-center wrapp my-4">

            <div class="custom-cat-btn" style="cursor: pointer;" *ngFor="let n of data_types"
                (click)="applyTypeFilter(n?.name)" [ngClass]="currentTypeFilter == n?.name ? 'active' : ''">
                <span class="custom-cat-btn-num">{{counter(n?.name).toString()}}</span>
                <span><i class="pi-fw {{n?.icon}} mx-2 icon-1-2rem"></i></span>
                <span>{{n?.arabic}}</span>
            </div>

        </div>
    </div>

    <div class="container-fluid max-width p-0 py-4 111">
        <div class="row">

            <div class="col-md-4 col-12 my-2 poss-rel">

                <span class="circle-numer">
                    <span *ngFor="let i of pages" class="circle-num-ui"
                        [ngClass]="currentPage == changeToNumber(i) ? 'active' : ''"
                        (click)="currentPage=changeToNumber(i); changePage(currentPage)">{{i}}</span>
                </span>

                <div class="card border-none card-mobile-alignment">
                    <div class="d-flex justify-content-between align-items-center mx-3">

                        <span class="custom-pagination-text">{{"results" | translator}} <br>{{currentPage * 10}} - {{first+rows >
                            totalRecords ? totalRecords : first+rows}} {{"from" | translator}} {{ totalRecords }}</span>
                        <div class="d-flex">
                            <span class="custom-pagination" (click)="moveToLast(true)"><i
                                    class="pi pi-fw pi-angle-double-right icon-x2"></i></span>
                            <span class="custom-pagination" (click)="changePage(currentPage - 1)"><i
                                    class="pi pi-fw pi-angle-right icon-x2"></i></span>
                            <span class="custom-pagination" (click)="changePage(currentPage + 1)"><i
                                    class="pi pi-fw pi-angle-left icon-x2"></i></span>
                            <span class="custom-pagination" (click)="moveToLast(false)"><i
                                    class="pi pi-fw pi-angle-double-left icon-x2"></i></span>
                        </div>

                    </div>

                    <div class="d-flex p-3">
                        <span class="p-float-label w-100">
                            <input type="text" id="float-label" class="w-100" (keyup)="applyFilterGlobal($event, 'contains')" pInputText
                                placeholder='{{"Search for a name or number" | translator}}' />
                            <label for="float-label">{{"Discus" | translator}}</label>
                        </span>
                    </div>

                    <p-dataView #dv *ngIf="data.length > 0" [value]="data" [rows]="10" [paginator]="true"
                        filterBy="name,fields.data,id,type.name,type.arabic,active" [sortField]="sortField"
                        [sortOrder]="sortOrder" (onPage)="onPageChange($event)" paginatorPosition="none"
                        emptyMessage='{{"There is no data" | translator}}'>

                        <ng-template let-item let-index="rowIndex" pTemplate="listItem">
                            <div class="list-item custom-w-90 d-flex flex-row flex-nowrap flex-wrap align-items-center"
                                [ngClass]="currentItem._id == item._id ? 'active' : ''" (click)="changeView(item)">

                                <p-button [label]="(index+1) + ((currentPage-1)*10)"
                                    styleClass="p-button-outline p-button-sm p-button-text indexnum m-2"></p-button>

                                <div>
                                    <p class="mb-0">{{item.id}}</p>
                                    <p><b style="line-height: 2.1rem;"
                                            [innerHTML]="item.name  | highlight: searchQuery"></b></p>
                                </div>

                            </div>
                        </ng-template>

                    </p-dataView>
                </div>
                
            </div>

            <div class="col-md-8 col-12 my-2">
                <div class="row d-flex justify-content-between flex-start mob-flex-column mb-4">
                    <!-- <h2 [innerHTML]="currentItem.name | highlight: searchQuery" class="card-title manage-margin"
                        style="font-weight: 600; color: var(--color-1)"></h2> -->

                    <!-- New Changes -->
                    <div class="col-md-8 col-12 d-flex my-2">
                        <div *ngIf="hasPermission('u') && editPermission" class="d-flex align-items-center">
                            <i [hidden]="editFlag==true" (click)="editFlag=true"
                                class="pi pi-fw pi-pencil edit-btn"></i>
                            <i [hidden]="editFlag==false" (click)="editFlag=false"
                                class="pi pi-times-circle edit-btn"></i>
                        </div>
                        <div class="column pos-rel w-100">
                            <h2 [hidden]="editFlag" class="v4-color-white"
                                [innerHTML]="currentItem.name | highlight: searchQuery"
                                style="font-weight: 600;">
                            </h2>
                            <label [hidden]="editFlag==false" class="name-position v4-color-white">{{"The address" | translator}}</label>
                            <input [hidden]="!editFlag" pInputText [(ngModel)]="currentItem.name"
                                class="w-100 edit-input-ui" [id]="currentItem.name" type="text">
                        </div>
                    </div>


                    <div class="col-md-4 col-12">
                        <div class="d-flex justify-content-end">
                            <span class="btn-flex mx-1">
                                <span class="d-flex flex-column">
                                    <span class="btn-css mx-2">{{"Last updated" | translator}}</span>
                                    <span class="btn-css mx-2 font-0_8rem font-weight-200">{{currentItem.updatedAt |
                                        date:'MMMM d, y | h:mm:ss a'}}</span>
                                </span>
                                <span class="icon-box">
                                    <i class="pi pi-calendar font-500"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <p-messages [(value)]="messages" [enableService]="false"></p-messages>

                <!-- <div class="d-flex flex-row align-items-center wrapp">

                    <span class="d-flex align-items-center my-1"
                        *ngFor="let item of currentItem.breadcrumbs; let i = index" [routerLink]="item.routerLink">
                        <span class="custom-bredcrum-btn d-flex align-items-center">
                            <i [hidden]="item.image" class="{{item.icon}} me-1"></i>
                            <img [hidden]="!item.image" [src]="staticURL+item.image"
                                style="max-height: 1.2rem; max-width: 1.2rem;" class="blacknWhite img-fluid me-1">
                            {{item.label}}
                        </span>
                        <span class=""><i class="pi pi-fw pi-angle-left"></i></span>

                    </span>

                </div> -->

                <p-accordion class="w-full" [multiple]="true" [activeIndex]="0"
                    *ngIf="currentItem && currentItem.fields.length > 0">
                    <span *ngFor="let field of currentItem?.fields; let i = index">
                        <p-accordionTab *ngIf="field.data && field.data != '' && field.data !=null" class="my-3"
                            iconPos="end" [selected]="i==0 || i==1">
                            <ng-template pTemplate="header">
                                <div class="d-flex align-items-center">
                                    <p-checkbox (click)="$event.stopPropagation()"  [hidden]="!editFlag" [(ngModel)]="field.isChecked" class="shadow"
                                        [binary]="true" inputId="binary"></p-checkbox>
                                    <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                                    <span class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <div *ngIf="!editFlag;" class="row">
                                    <!-- For View -->
                                    <div class="col-12">
                                        <div [ngSwitch]="getFieldType(field.label?.type)">
                                            <!-- For text -->
                                            <div *ngSwitchCase="'text'">
                                                <div class="line-space v4-color-white mb-0 datacontent" *ngIf="field.data"
                                                    [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                                </div>
                                            </div>
                                            <!-- Rich text -->
                                            <div *ngSwitchCase="'Rich text'">
                                                <div class="line-space v4-color-white mb-0 datacontent" *ngIf="field.data"
                                                    [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                                </div>
                                            </div>
                                            <div *ngSwitchCase="'Upload Image'">
                                                <img [hidden]="field.data == ''" class="img-fluid upload-img"
                                                    [src]="GlobalConstants.staticFilesURL+field.data">
                                            </div>
                                            <div *ngSwitchCase="'Upload Document'">
                                                <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                                                    [href]="GlobalConstants.staticFilesURL+field.data">
                                                    <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                                                </a>

                                            </div>
                                            <div *ngSwitchCase="'Data Item'">
                                                <p class="color-bold">{{field?.data?.name}}</p>
                                                <p-accordion class="w-full" [multiple]="true">
                                                    <p-accordionTab class="my-3"
                                                        *ngFor="let field of field.data.fields; let i = index"
                                                        iconPos="end">
                                                        <ng-template pTemplate="header">
                                                            <div class="d-flex align-items-center">
                                                                <i [ngClass]="field.label?.icon + ' font-1_2rem'"
                                                                    class="m-2"></i>
                                                                <span
                                                                    class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
                                                            </div>
                                                        </ng-template>
                                                        <ng-template pTemplate="content">
                                                            <div class="row">
                                                                <div class="col-10">
                                                                    <div [ngSwitch]="getFieldType(field.label?.type)">
                                                                        <!-- For text -->
                                                                        <div *ngSwitchCase="'text'">
                                                                            <div class=" line-space v4-color-white mb-0 datacontent "
                                                                                *ngIf="field.data"
                                                                                [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                                                            </div>
                                                                        </div>
                                                                        <!-- Rich text -->
                                                                        <div *ngSwitchCase="'Rich text'">
                                                                            <div class=" line-space v4-color-white mb-0 datacontent "
                                                                                *ngIf="field.data"
                                                                                [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                                                            </div>
                                                                        </div>
                                                                        <div *ngSwitchCase="'Upload Image'">
                                                                            <img [hidden]="field.data == ''"
                                                                                class="img-fluid upload-img"
                                                                                [src]="GlobalConstants.staticFilesURL+field.data">
                                                                        </div>
                                                                        <div *ngSwitchCase="'Upload Document'">
                                                                            <a class="doc-view"
                                                                                [hidden]="field.data == ''"
                                                                                target="_blank"
                                                                                [href]="GlobalConstants.staticFilesURL+field.data">
                                                                                <i [hidden]="field.data == ''"
                                                                                    class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                                                                            </a>

                                                                        </div>
                                                                        <div *ngSwitchCase="'Data Item'">
                                                                        </div>
                                                                        <div *ngSwitchDefault>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-template>
                                                    </p-accordionTab>
                                                </p-accordion>
                                            </div>
                                            <div *ngSwitchDefault></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-2 d-flex justify-content-end">
                                        <div *ngIf="hasPermission('u') && editPermission" class="editbutton"
                                            (click)="editFlag = i; editDataSave(field.data)">
                                            <p-button icon="pi pi-fw pi-pencil"></p-button>
                                        </div>
                                    </div> -->
                                </div>

                                <div *ngIf="editFlag;" class="d-flex justify-content-between">

                                    <div class="w-100" [ngSwitch]="getFieldType(field.label?.type)">
                                        <!-- For text -->
                                        <div *ngSwitchCase="'text'">
                                            <i class="pi pi-clone"></i>
                                            <input pInputText [(ngModel)]="field.data" class="w-100" [id]="field.label"
                                                type="text">
                                        </div>
                                        <!-- Rich text -->
                                        <div *ngSwitchCase="'Rich text'">
                                            <p-editor [(ngModel)]="field.data" [style]="{'height':'320px'}"></p-editor>
                                        </div>
                                        <div *ngSwitchCase="'Upload Image'">
                                            <img [hidden]="field.data == ''" class="img-fluid upload-img-dActive"
                                                [src]="GlobalConstants.staticFilesURL+field.data">
                                            <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                                [url]="apilink+'file/data'" [auto]="true" chooseLabel="Browse"
                                                accept="image/*" [maxFileSize]="1000000"
                                                (onUpload)="field.data = $event.originalEvent.body.data"></p-fileUpload>
                                        </div>
                                        <div *ngSwitchCase="'Upload Document'">
                                            <a class="doc-view-dActive" [hidden]="field.data == ''" target="_blank"
                                                [href]="GlobalConstants.staticFilesURL+field.data">
                                                <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                                            </a>
                                            <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                                [url]="apilink+'file/data'" [auto]="true" chooseLabel="Add File"
                                                [maxFileSize]="100000000"
                                                (onUpload)="field.data = $event.originalEvent.body.data"></p-fileUpload>
                                        </div>
                                        <div *ngSwitchCase="'Data Item'">
                                            <button type="submit" (click)="toggleModal(i)"
                                            pButton pRipple label='{{"to update" | translator}}'
                                            icon="pi pi-fw pi-plus-circle"
                                            class="w-full my-3"></button>
                                        <p-dialog [blockScroll]="true" [draggable]="false"header='{{"Select a service" | translator}}'
                                            [(visible)]="modalVisibilities[i]"
                                            [style]="{width: '70vw'}">
                                            <app-select-service
                                                (currentDataItem)="changeCurrentDataItem($event,field ,i)"></app-select-service>
                                        </p-dialog>
                                        <p class="font-bold" *ngIf="field.data">
                                            {{field.data.name}}</p>
                                        </div>
                                        <div *ngSwitchDefault></div>
                                    </div>
                                </div>
                            </ng-template>
                        </p-accordionTab>
                    </span>
                </p-accordion>
                <div class="d-flex justify-content-between my-3">
                    <div *ngIf="!currentItem.signed || currentItem.signed.status == false"
                        class="d-flex justify-content-start flex-start mob-flex-column">

                        <div class="d-flex my-1">
                            <span class="btn-flex mx-1">
                                <span class="d-flex flex-column">
                                    <span class="btn-css mx-2">{{"Not approved by the expert" | translator}}</span>
                                    <!-- <span class="btn-css mx-2 font-0_8rem font-weight-200">
                                        {{currentItem.updatedAt | date:'MMMM,d, y'}}
                                    </span> -->
                                </span>
                                <span class="icon-box">
                                    <i class="pi pi-exclamation-circle font-500"></i>
                                </span>
                            </span>
                        </div>
                    </div>

                    <div *ngIf="currentItem.signed || currentItem.signed.status == true"
                        class="d-flex justify-content-start flex-start mob-flex-column">

                        <div class="d-flex my-1">
                            <span class="btn-flex mx-1">
                                <span class="d-flex flex-column">
                                    <span class="btn-css mx-2">{{"Not approved by the expert" | translator}}</span>
                                    
                                    <!-- <span class="btn-css mx-2 font-0_8rem font-weight-200">
                                        {{currentItem.updatedAt | date:'MMMM,d, y'}}
                                    </span> -->
                                </span>
                                <span class="icon-box">
                                    <i class="pi pi-exclamation-circle font-500"></i>
                                </span>
                            </span>
                        </div>
                    </div>

                    <div class="d-flex justify-content-end my-1">
                        <span class="btn-flex mx-1 p-3" (click)="deleteService()">
                            <i class="pi pi-trash font-500 font-1_2rem"></i>
                        </span>
                        <button class="btn-flex mx-1 p-3" [useExistingCss]="true"
                            styleSheetFile="search-result.component.scss"
                            [printStyle]="{'#print-data':{'display':'block'},'*':{'direction': 'rtl'},'html':{'direction': 'rtl'},'body':{'direction': 'rtl'}}"
                            printSectionId="print-data" ngxPrint>
                            <i class="pi pi-print font-500 font-1_2rem"></i>
                        </button>
                        <span class="btn-flex mx-1 p-3" (click)="copyLinkToClipboard()">
                            <i class="pi pi-link font-500 font-1_2rem"></i>
                        </span>
                        <span [hidden]="editFlag==false" class="mx-1">
                            <button *ngIf="hasPermission('u') && editPermission" class="Ersaal-btn"
                                (click)="updateData()"><i class="pi pi-check"></i>{{"OK" | translator}}</button>
                        </span>
                        <!-- <span *ngIf="hasPermission('u') && editPermission" class="btn-flex mx-1 p-3" (click)="updateData()">
                            <i class="pi pi-file-edit font-500 font-1_2rem"></i>
                        </span> -->
                    </div>
                </div>

                <!-- create comment -->
                <div class="card rating-card border-none" id="comment-section">
                    <div>
                        <span class="font-weight-bold"><i class="pi pi-comments mx-2"></i>{{"If there are any comments, write your comment" | translator}} </span>
                        <div class="d-flex align-items-center flex-column mt-3">
                            <span class="p-float-label m-2 w-100">
                                <textarea class="comment-box w-100" id="float-input" rows="5" pInputTextarea
                                    [(ngModel)]="commentText"></textarea>
                                <label for="float-input">{{"comment" | translator}}</label>
                            </span>
                            <button class="comment-btn" (click)="makeComment()"><i
                                    class="pi pi-check mx-2"></i>{{"send" | translator}}</button>
                            <p-messages [(value)]="messages" [enableService]="true"></p-messages>
                        </div>
                    </div>

                </div>
                <!-- end create comment -->
                
            </div>
        </div>

    </div>
</div>

<!-- Printing Service Use Only -->
<div style="display: none;width: 100%;" id="print-data" *ngIf="currentItem">
    <h2 [hidden]="editFlag" class="card-title" style="font-weight: 600; color: var(--color-1);margin-bottom: 2rem;">
        {{currentItem.name}}</h2>
    <!-- <p-dataView #dv [value]="data" filterBy="name,fields.data,id,type.name,type.arabic,active" [rows]="10"
        [paginator]="true" [sortField]="sortField" [sortOrder]="sortOrder" (onPage)="onPageChange($event)"
        paginatorPosition="none" emptyMessage="لاتوجد بيانات">

        <ng-template let-item let-index="rowIndex" pTemplate="listItem">
            <div class="list-item custom-w-90 d-flex flex-row flex-nowrap flex-wrap align-items-center"
                [ngClass]="currentItem._id == item._id ? 'active' : ''" (click)="changeView(item)">

                <p-button label="{{(index+1) + ((currentPage - 1) * 10)}}"
                    styleClass="p-button-outline p-button-sm p-button-text indexnum m-2"></p-button>

                <div>
                    <p class="mb-0">{{item.id}}</p>
                    <p><b>{{item.name}}</b></p>
                </div>

            </div>
        </ng-template>

    </p-dataView> -->

    <div class="d-flex flex-row w-100 left-0 pb-2 wrapp">
        <ng-container *ngIf="currentItem && currentItem.breadcrumbs && currentItem.breadcrumbs.length > 0">
            <span class="d-flex flex-row align-items-center" *ngFor="let parent of sortByDepth(currentItem?.breadcrumbs)">
                <span class="btn-flex custom-bredcrum-btn ou-item  align-items-center" style="background-color: grey;">
                    <span class="btn-css  mx-2 font-0_5rem" role="button"
                        [routerLink]="'/category/'+parent.id">{{parent.label}}</span>
                    <span class="icon-box" style="background-color: grey;">
                        <img src="{{staticURL + parent?.icon}}" *ngIf="checkisImg(parent?.icon); else elseBlock"
                            class="img-fluid" alt="">
                        <ng-template #elseBlock>
                            <i class="pi pi-{{parent.icon}} img-fluid"></i>
                        </ng-template>
                    </span>
                </span>
                <span>
                    <i class="pi pi-fw pi-angle-left"></i>
                </span>
            </span>
        </ng-container>
        <span style="background-color: grey;" class=" my-1 btn-flex mx-1 ou-item active custom-bredcrum-btn align-items-center">
            <span role="button" class="btn-css mx-2 font-0_5rem"
                [routerLink]="'/category/'+currentItem?.id">{{currentItem?.name}}</span>
            <span class="icon-box" style="background-color: grey;">
                <img src="{{staticURL + currentItem?.image_sq}}" *ngIf="checkisImg(currentItem?.image_sq); else elseBlock"
                    class="img-fluid" alt="">
                <ng-template #elseBlock>
                    <i class="pi pi-{{currentItem?.image}} align-self-center"></i>
                </ng-template>
            </span>
        </span>
    </div>

    <div style="margin:1rem 0;"></div>
    <span class="hr"></span>
    <p-accordion class="w-full" [multiple]="true" [activeIndex]="0">
        <span *ngFor="let field of currentItem?.fields; let i = index">
            <p-accordionTab *ngIf="field.data && field.data != '' && field.data !=null" class="my-3" iconPos="end"
                [selected]="true">
                <ng-template pTemplate="header">
                    <div  class="d-flex align-items-center">
                        <p-checkbox (click)="$event.stopPropagation()" [hidden]="!editFlag" [(ngModel)]="field.isChecked" class="shadow" [binary]="true"
                            inputId="binary"></p-checkbox>
                        <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                        <span class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
                    </div>
                </ng-template>
                <ng-template pTemplate="content">
                    <div *ngIf="!editFlag;" class="row">
                        <!-- For View -->
                        <div class="col-12">
                            <div [ngSwitch]="getFieldType(field.label?.type)">
                                <!-- For text -->
                                <div *ngSwitchCase="'text'">
                                    <div class=" line-space v4-color-white mb-0 datacontent" *ngIf="field.data"
                                        [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                    </div>
                                </div>
                                <!-- Rich text -->
                                <div *ngSwitchCase="'Rich text'">
                                    <div class=" line-space v4-color-white mb-0 datacontent" *ngIf="field.data"
                                        [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                    </div>
                                </div>
                                <div *ngSwitchCase="'Upload Image'">
                                    <img [hidden]="field.data == ''" class="img-fluid upload-img"
                                        [src]="GlobalConstants.staticFilesURL+field.data">
                                </div>
                                <div *ngSwitchCase="'Upload Document'">
                                    <a class="doc-view" [hidden]="field.data == ''" target="_blank"
                                        [href]="GlobalConstants.staticFilesURL+field.data">
                                        <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                                    </a>

                                </div>
                                <div *ngSwitchCase="'Data Item'">
                                    <p class="color-bold">{{field?.data?.name}}</p>
                                    <p-accordion class="w-full" [multiple]="true">
                                        <p-accordionTab class="my-3" [selected]="true"
                                            *ngFor="let field of field.data.fields; let i = index" iconPos="end">
                                            <ng-template pTemplate="header">
                                                <div class="d-flex align-items-center">
                                                    <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                                                    <span
                                                        class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
                                                </div>
                                            </ng-template>
                                            <ng-template pTemplate="content">
                                                <div class="row">
                                                    <div class="col-10">
                                                        <div [ngSwitch]="getFieldType(field.label?.type)">
                                                            <!-- For text -->
                                                            <div *ngSwitchCase="'text'">
                                                                <div class=" line-space v4-color-white mb-0 datacontent"
                                                                    *ngIf="field.data"
                                                                    [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                                                </div>
                                                            </div>
                                                            <!-- Rich text -->
                                                            <div *ngSwitchCase="'Rich text'">
                                                                <div class=" line-space v4-color-white mb-0 datacontent"
                                                                    *ngIf="field.data"
                                                                    [innerHTML]="field.data | highlight: searchQuery | safeHTML">
                                                                </div>
                                                            </div>
                                                            <div *ngSwitchCase="'Upload Image'">
                                                                <img [hidden]="field.data == ''"
                                                                    class="img-fluid upload-img"
                                                                    [src]="GlobalConstants.staticFilesURL+field.data">
                                                            </div>
                                                            <div *ngSwitchCase="'Upload Document'">
                                                                <a class="doc-view" [hidden]="field.data == ''"
                                                                    target="_blank"
                                                                    [href]="GlobalConstants.staticFilesURL+field.data">
                                                                    <i [hidden]="field.data == ''"
                                                                        class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                                                                </a>

                                                            </div>
                                                            <div *ngSwitchCase="'Data Item'">
                                                            </div>
                                                            <div *ngSwitchDefault>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </p-accordionTab>
                                    </p-accordion>
                                </div>
                                <div *ngSwitchDefault></div>
                            </div>
                        </div>
                        <!-- <div class="col-2 d-flex justify-content-end">
                            <div *ngIf="hasPermission('u') && editPermission" class="editbutton"
                                (click)="editFlag = i; editDataSave(field.data)">
                                <p-button icon="pi pi-fw pi-pencil"></p-button>
                            </div>
                        </div> -->
                    </div>

                    <div *ngIf="editFlag;" class="d-flex justify-content-between">

                        <div class="w-100" [ngSwitch]="getFieldType(field.label?.type)">
                            <!-- For text -->
                            <div *ngSwitchCase="'text'">
                                <i class="pi pi-clone"></i>
                                <input pInputText [(ngModel)]="field.data" class="w-100" [id]="field.label" type="text">
                            </div>
                            <!-- Rich text -->
                            <div *ngSwitchCase="'Rich text'">
                                <p-editor [(ngModel)]="field.data" [style]="{'height':'320px'}"></p-editor>
                            </div>
                            <div *ngSwitchCase="'Upload Image'">
                                <img [hidden]="field.data == ''" class="img-fluid upload-img-dActive"
                                    [src]="GlobalConstants.staticFilesURL+field.data">
                                <p-fileUpload mode="basic" chooseLabel="Choose" name="file" [url]="apilink+'file/data'"
                                    [auto]="true" chooseLabel="Browse" accept="image/*" [maxFileSize]="1000000"
                                    (onUpload)="field.data = $event.originalEvent.body.data"></p-fileUpload>
                            </div>
                            <div *ngSwitchCase="'Upload Document'">
                                <a class="doc-view-dActive" [hidden]="field.data == ''" target="_blank"
                                    [href]="GlobalConstants.staticFilesURL+field.data">
                                    <i [hidden]="field.data == ''" class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                                </a>
                                <p-fileUpload mode="basic" chooseLabel="Choose" name="file" [url]="apilink+'file/data'"
                                    [auto]="true" chooseLabel="Add File" [maxFileSize]="100000000"
                                    (onUpload)="field.data = $event.originalEvent.body.data"></p-fileUpload>
                            </div>
                            <div *ngSwitchCase="'Data Item'">
                                <p>{{field?.data?.name}}</p>
                                <p-accordion class="w-full" [multiple]="true">
                                    <p-accordionTab class="my-3" *ngFor="let field of field.data.fields; let i = index"
                                        iconPos="end" [selected]="true">
                                        <ng-template pTemplate="header">
                                            <div class="d-flex align-items-center">
                                                <i [ngClass]="field.label?.icon + ' font-1_2rem'" class="m-2"></i>
                                                <span
                                                    class="vertical-align-middle font-1_1rem">{{field.label?.name}}</span>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="content">
                                            <div class="row">
                                                <div class="col-10">
                                                    <div [ngSwitch]="getFieldType(field.label?.type)">
                                                        <!-- For text -->
                                                        <!-- For text -->
                                                        <div *ngSwitchCase="'text'">
                                                            <i class="pi pi-clone"></i>
                                                            <input pInputText [(ngModel)]="field.data" class="w-100"
                                                                [id]="field.label" type="text">
                                                        </div>
                                                        <!-- Rich text -->
                                                        <div *ngSwitchCase="'Rich text'">
                                                            <p-editor [(ngModel)]="field.data"
                                                                [style]="{'height':'320px'}"></p-editor>
                                                        </div>
                                                        <div *ngSwitchCase="'Upload Image'">
                                                            <img [hidden]="field.data == ''"
                                                                class="img-fluid upload-img-dActive"
                                                                [src]="GlobalConstants.staticFilesURL+field.data">
                                                            <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                                                [url]="apilink+'file/data'" [auto]="true"
                                                                chooseLabel="Browse" accept="image/*"
                                                                [maxFileSize]="1000000"
                                                                (onUpload)="field.data = $event.originalEvent.body.data"></p-fileUpload>
                                                        </div>
                                                        <div *ngSwitchCase="'Upload Document'">
                                                            <a class="doc-view-dActive" [hidden]="field.data == ''"
                                                                target="_blank"
                                                                [href]="GlobalConstants.staticFilesURL+field.data">
                                                                <i [hidden]="field.data == ''"
                                                                    class="pi pi-file mx-2"></i>{{"Add file" | translator}}
                                                            </a>
                                                            <p-fileUpload mode="basic" chooseLabel="Choose" name="file"
                                                                [url]="apilink+'file/data'" [auto]="true"
                                                                chooseLabel="Add File" [maxFileSize]="100000000"
                                                                (onUpload)="field.data = $event.originalEvent.body.data"></p-fileUpload>
                                                        </div>
                                                        <div *ngSwitchDefault></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </p-accordionTab>
                                </p-accordion>
                            </div>
                            <div *ngSwitchDefault></div>
                        </div>
                    </div>
                </ng-template>
            </p-accordionTab>
        </span>
    </p-accordion>
</div>

<p-toast></p-toast>


<!-- Confirm Modal -->
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label='{{"cancellation" | translator}}' (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check"  label='{{"OK" | translator}}'  (click)="cd.accept()"></button>
          </ng-template>
</p-confirmDialog>

<app-footer></app-footer>